import { render } from "./BoostedVouchersPage.vue?vue&type=template&id=7ae14bc7&scoped=true"
import script from "./BoostedVouchersPage.vue?vue&type=script&lang=js"
export * from "./BoostedVouchersPage.vue?vue&type=script&lang=js"

import "./BoostedVouchersPage.vue?vue&type=style&index=0&id=7ae14bc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae14bc7"]])

export default __exports__